{
  "title": "Grasping Vine",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level conjuration",
  "level": 4,
  "castingTime": "1 bonus action",
  "range": "30 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You conjure a vine that sprouts from the ground in an unoccupied space of your choice that you can see within range. When you cast this spell, you can direct the vine to lash out at a creature within 30 feet of it that you can see. That creature must succeed on a Dexterity saving throw or be pulled 20 feet directly toward the vine.",
    "Until the spell ends, you can direct the vine to lash out at the same creature or another one as a bonus action on each of your turns."
  ],
  "spellLists": ["druid", "ranger"]
}
